// @flow
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Capsule } from 'moods-react/Capsule';
import { Tooltip, tooltipCaretDirections, tooltipPosition } from 'moods-react/Tooltip';
import messages from '../../../data/products';
import AnalyticsClient from '../../../clients/AnalyticsClient';
import productEvents from '../../../analytics/events/products';

import './ProductImageCapsule.scss';

type Props = {
  text: string,
  tooltipText: string,
  colour: string,
};

type Context = {
  intl: Object,
};

const ProductImageCapsule = (props: Props, context: Context) => {
  const classes = classNames('product-image-capsule-component', {
    [`product-image-capsule-component--${props.colour}`]: Boolean(props.colour),
  });

  return (
    <div className={classes}>
      <div className="product-image-capsule-component__content">
        <span className="product-image-capsule-component__hovered-container fade-in-children__parent">
          <Capsule
            className="product-image-capsule-component__capsule"
            colour={props.colour}
            onMouseEnter={() => AnalyticsClient.trackEvent(productEvents.tooltipHover(props.text))}
          >
            {props.text}
          </Capsule>
          <span className="u-position-relative product-image-capsule-component__tooltip-wrapper fade-in-children__child">
            <Tooltip
              panel
              position={tooltipPosition.BELOW_LEFT}
              caretDirection={tooltipCaretDirections.TOP_RIGHT}
              heading={context.intl.formatMessage(messages.productApprovalTooltipTitle)}
            >
              {props.tooltipText}
            </Tooltip>
          </span>
        </span>
      </div>
    </div>
  );
};

ProductImageCapsule.displayName = 'ProductImageCapsule';

ProductImageCapsule.contextTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
};

export default ProductImageCapsule;
